var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import useInnerWidth from 'syf-js-utilities/hooks/useInnerWidth';
import { colors } from '../../../../defaultTheme';
const TR = styled.tr `
  ${({ onClick, theme }) => onClick &&
    `
    &:hover {
      background-color: ${theme.hoverBackground};
      cursor: pointer;
    }
  `}

  ${({ breakpoint }) => breakpoint &&
    `
    @media (max-width: ${breakpoint}px) {
      border-bottom: 1px solid ${colors.lightGrey};
      display: flex;
      flex-direction: column;
      position: relative;
      margin: 0;
      padding: 0;
      
      td:first-of-type  {
        padding: 12px;
      }
    }
  `}
`;
const THR = styled(TR) `
  ${({ breakpoint }) => breakpoint &&
    `
    @media (max-width: ${breakpoint}px) {
      display: none;
    }
  `}
`;
export const TableRow = (_a) => {
    var { className, onClick = null, breakpoint = 0, children } = _a, props = __rest(_a, ["className", "onClick", "breakpoint", "children"]);
    const currentWidth = useInnerWidth();
    return (_jsx(TR, Object.assign({ className: className, breakpoint: breakpoint, onClick: onClick }, props, { as: breakpoint && currentWidth < breakpoint ? 'ul' : '' }, { children: children })));
};
export const TableHeaderRow = (_a) => {
    var { className, breakpoint = 0, onClick = null, children } = _a, props = __rest(_a, ["className", "breakpoint", "onClick", "children"]);
    return (_jsx(THR, Object.assign({ className: className, breakpoint: breakpoint, onClick: onClick }, props, { children: children })));
};
